var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MagCeRawHtml",class:[
    _vm.data.el_class,
    _vm.data.animation_in ? ("animate__animated animate__" + (_vm.data.animation_in) + " animate__delay-1s") : '',
    _vm.data.animation_delay ? ("animate__delay-" + (_vm.data.animation_delay) + "s") : '',
    _vm.data.animation_infinite ? "animate__infinite" : '' ],style:(Object.assign({}, _vm.containerStyles)),attrs:{"id":_vm.data.el_id}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getPrasedData(_vm.data.content))}})])}
var staticRenderFns = []

export { render, staticRenderFns }